import React from 'react';
import styled from 'styled-components';
import { DialogText } from '../../styles/DialogStyles';

const Container = styled.div`
  padding: var(--spacing-space12) var(--spacing-space16);
  background-color: var(--color-global-grey200);
  border-radius: 4px;

  .container-item:not(:last-child) {
    margin-bottom: var(--spacing-space12);
  }
`;

interface Props {
  productName: string;
  skuPrice: string;
  weeklyTermPeriod: number;
  weeklyTermMessage: string;
  weeklyPrice: string;
}

function WeeklyBreakdown(props: Props) {
  const { productName, skuPrice, weeklyTermPeriod, weeklyTermMessage, weeklyPrice } = props;

  return (
    <Container>
      <DialogText
        data-testid="weekly-breakdown-product-name"
        size="m1"
        tag="h3"
        type="heading"
        dangerouslySetInnerHTML={{
          __html: productName,
        }}
      />

      <DialogText data-testid="weekly-breakdown-sku-price" size="m1" tag="p" type="paragraph">
        {skuPrice}
      </DialogText>

      <DialogText data-testid="weekly-breakdown-weekly-term-message" size="m1" tag="p" type="paragraph">
        <strong>{weeklyTermPeriod} weeks</strong> {weeklyTermMessage}
      </DialogText>

      <DialogText data-testid="weekly-breakdown-weekly-price" size="m1" tag="p" type="paragraph">
        <strong>{weeklyPrice}</strong> per week
      </DialogText>
    </Container>
  );
}

export default WeeklyBreakdown;
